import React from 'react';
import format from 'date-fns/format';

import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import RichTextContent from 'components/tiptap-editor/RichTextContent';

interface IMessage {
  isAdmin?: boolean;
  name?: string;
  text?: string;
  html?: string;
  created_at?: string;
}

interface IChatItemProps {
  message?: IMessage;
}

const ChatItem = ({ message }: IChatItemProps) => {
  const style: React.CSSProperties = {};
  const textStyle: React.CSSProperties = {};
  let name: string | undefined = '';
  if (message?.isAdmin) {
    style.backgroundColor = '#56aba9';
    textStyle.fontSize = 12;
    name = 'Sygrid';
  } else {
    if (message?.name && message.name.trim() !== '') {
      name = message.name[0];
    } else {
      name = undefined;
    }
  }
  const getTime = () => {
    const created_at = message?.created_at;
    if (created_at) {
      return format(parseInt(created_at, 10), 'HH:mm, yyyy-MM-dd');
    }
    return '';
  };

  return (
    <ListItem alignItems="flex-start" disableGutters>
      <ListItemAvatar>
        <Avatar variant="rounded" style={style}>
          <b style={textStyle}>{name}</b>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        secondary={
          message?.html ? (
            <RichTextContent html={message.html} />
          ) : (
            message?.text?.split(/\r?\n/).map((str, index) => <div key={`${index}_${str}`}>{str}</div>)
          )
        }
        primary={`${message?.isAdmin ? 'Sygrid' : message?.name} ${getTime()}`}
      />
    </ListItem>
  );
};

export default ChatItem;
